import { render } from "./EditOrganisationDailyReportSubHeader.vue?vue&type=template&id=09973e18"
import script from "./EditOrganisationDailyReportSubHeader.vue?vue&type=script&lang=js"
export * from "./EditOrganisationDailyReportSubHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__